import React from 'react';
import { PropTypes as PT } from 'prop-types';
import SVG from 'react-inlinesvg';
import classes from './ContactIcon.module.scss';

class ContactIcon extends React.PureComponent {
  render() {
    return (
      <div className={`${classes.contactIconContainer} statusIcon`}>
        <SVG src={this.props.icon} />
        {this.props.presence && (
          <div
            className={classes[this.props.presence]}
            style={{ ...this.props.presenceStyle }}
          />
        )}
      </div>
    );
  }
}

ContactIcon.propTypes = {
  presence: PT.string,
  icon: PT.string,
  presenceStyle: PT.object
};

export default ContactIcon;
